export const elementsCache: WeakMap<Element, number> = new WeakMap();
